import { Action } from '@ngrx/store';
import { type } from '../util';

export const ActionTypes = {
	LOADING: type('[User] loading '),
	PUT_LOGGED_IN: type('[User] put logged in'),
	PUT_CANCEL_LOGIN: type('[User] put cancel login'),
	PUT_USER_INFO: type('[User] put user info'),
	PUT_USER_PNRS: type('[User] put user pnrs'),
	PUT_COUNTRY: type('[User] put country'),
	PUT_LANGUAGE: type('[User] put language'),
	PUT_MARKET: type('[User] put market'),
	PUT_CONFIRM_DIALOG: type('[User] put confirm_dialog_open'),
	PUT_IS_CORPORATE: type('[User] put is_corporate'),
	PUT_EXTEND_SESSION: type('[User] put extendSession'),
	PUT_USER_POINTS: type('[User] put user points'),
	PUT_MARKET_LOADING: type('[User] put market loading'),
	PUT_DEEPLINK_MARKET: type('[User] put deeplink market'),
	RESET: type('[User] Reset')
};

export class LoadingAction implements Action {
	type = ActionTypes.LOADING;

	/**
	 *Creates an instance of LoadingAction.
	 * @param {*} [payload]
	 * @memberof LoadingAction
	 */
	constructor(public payload?) { }
}

export class PutLoggedInAction implements Action {
	type = ActionTypes.PUT_LOGGED_IN;

	/**
	 *Creates an instance of PutLoggedInAction.
	 * @param {*} payload
	 * @memberof PutLoggedInAction
	 */
	constructor(public payload: any) { }
}

export class PutCancelLogIn implements Action {
	type = ActionTypes.PUT_CANCEL_LOGIN;

	/**
	 *Creates an instance of PutCancelLogIn.
	 * @param {*} payload
	 * @memberof PutCancelLogIn
	 */
	constructor(public payload: any) { }
}

export class PutUserInfoAction implements Action {
	type = ActionTypes.PUT_USER_INFO;

	/**
	 *Creates an instance of PutUserInfoAction.
	 * @param {*} payload
	 * @memberof PutUserInfoAction
	 */
	constructor(public payload: any) { }
}

export class PutUserPNRSAction implements Action {
	type = ActionTypes.PUT_USER_PNRS;

	/**
	 *Creates an instance of PutUserInfoAction.
	 * @param {*} payload
	 * @memberof PutUserInfoAction
	 */
	constructor(public payload: any) { }
}

export class PutCountryAction implements Action {
	type = ActionTypes.PUT_COUNTRY;

	/**
	 *Creates an instance of PutCountryAction.
	 * @param {*} payload
	 * @memberof PutCountryAction
	 */
	constructor(public payload: any) { }
}

export class PutLanguageAction implements Action {
	type = ActionTypes.PUT_LANGUAGE;

	/**
	 *Creates an instance of PutLanguageAction.
	 * @param {*} payload
	 * @memberof PutLanguageAction
	 */
	constructor(public payload: any) { }
}

export class PutMarketAction implements Action {
	type = ActionTypes.PUT_MARKET;

	/**
	 *Creates an instance of PutMarketAction.
	 * @param {*} payload
	 * @memberof PutMarketAction
	 */
	constructor(public payload: any) { }
}

export class PutConfirmDialogAction implements Action {
	type = ActionTypes.PUT_CONFIRM_DIALOG;

	/**
	 *Creates an instance of PutLanguageAction.
	 * @param {*} payload
	 * @memberof PutConfirmDialogAction
	 */
	constructor(public payload: any) { }
}

export class PutIsCorporateAction implements Action {
	type = ActionTypes.PUT_IS_CORPORATE;

	/**
	 *Creates an instance of PutIsCorporateAction.
	 * @param {boolean} payload
	 * @memberof PutIsCorporateAction
	 */
	constructor(public payload: boolean) { }
}

export class PutExtendSessionAction implements Action {
	type = ActionTypes.PUT_EXTEND_SESSION;

	/**
	 *Creates an instance of PutExtendSessionAction.
	 * @param {boolean} payload
	 * @memberof PutExtendSessionAction
	 */
	constructor(public payload: boolean) { }
}

export class PutUserPoints implements Action {
	type = ActionTypes.PUT_USER_POINTS;

	/**
	 *Creates an instance of PutUserPoints.
	 * @param {boolean} payload
	 * @memberof PutUserPoints
	 */
	constructor(public payload: any) { }
}

export class PutMarketLoadingAction implements Action {
	type = ActionTypes.PUT_MARKET_LOADING;

	/**
	 *Creates an instance of PutMarketLoadingAction.
	 * @param {boolean} payload
	 * @memberof PutMarketLoadingAction
	 */
	constructor(public payload: boolean) { }
}

export class PutDeeplinkMarket implements Action {
	type = ActionTypes.PUT_DEEPLINK_MARKET;

	/**
	 *Creates an instance of PutDeeplinkMarket.
	 * @param {*} payload
	 * @memberof PutDeeplinkMarket
	 */
	constructor(public payload: string) { }
}

export class ResetAction implements Action {
	type = ActionTypes.RESET;
	/**
	 *Creates an instance of ResetAction.
	 * @param {*} [payload]
	 * @memberof ResetAction
	 */
	constructor(public payload?) { }
}

export type Actions = LoadingAction | PutLoggedInAction | PutUserInfoAction | PutUserPNRSAction | PutCountryAction | PutCancelLogIn | PutMarketAction | PutLanguageAction | PutConfirmDialogAction | PutIsCorporateAction | PutExtendSessionAction | PutUserPoints | PutMarketLoadingAction | PutDeeplinkMarket | ResetAction;
